/*
  src/redux/callAuth.js

  Created by erikchristensen on 10/19/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/


import {
  AUTH_URL,
  APPLICATION_ID,
  APPLICATION_SECRET
} from '../../config';

import {
  AuthenticationError,
  RequestError,
  ServerError
} from './errors/types';

function toQueryString(obj){
  let parts = [];
  for (let i in obj) {
    if (obj.hasOwnProperty(i)){
      parts.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`);
    }
  }
  return parts.join('&');
}

// callAPI({
//   method:'GET',
//   path:'/foo',
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })

export default function callAuth(options){
  return function(dispatch,getState){
    const token = window.btoa(APPLICATION_ID+':'+APPLICATION_SECRET),
      headers = new Headers();

    headers.append('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
    headers.append('Accept','application/json');
    headers.append('Authorization','Basic '+token);

    dispatch({
      type:options.begin.type,
      payload:options.begin.payload ? options.begin.payload() : null
    });

    return fetch(AUTH_URL+options.path,{
      method:options.method || 'GET',
      body:options.body ? toQueryString(options.body) : undefined,
      headers:headers
    })
      .then((res) => {
        if(options.allow404 && res.status === 404){
          return res.json();
        }

        if(res.status === 400) throw new RequestError();
        if(res.status === 401) throw new AuthenticationError();
        if(!res.ok) throw new ServerError();

        return res.json();
      })
      .then((res) => {
        dispatch({
          type:options.success.type,
          payload:options.success.payload ? options.success.payload(res) : res
        });

        if(options.success.result){
          return options.success.result(res);
        } else if(options.success.payload){
          return options.success.payload(res);
        } else {
          return res;
        }
      })
      .catch((err) => {
        dispatch({
          type:options.failure.type,
          payload:options.failure.payload ? options.failure.payload(err) : err,
          error:true
        });

        throw err;
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/callAuth.js